import React from 'react';

const LoadingChart = () => {
  return (
    <div className="load-spin">
      <span>
        <i />
      </span>
    </div>
  );
};

export default LoadingChart;
